import React from 'react'
import Image from "next/image"
import { Statistic } from '@/types/Statistic'
import BellRingIcon from '@/public/images/icons/bell-ring.svg'
import RocketIcon from '@/public/images/icons/rocket.svg'
import FileCheckIcon from '@/public/images/icons/file-check.svg'
import CalendarPlusIcon from '@/public/images/icons/calendar-plus.svg'

const Statistics = ({
  eventStatistics,
  status,
}: {
  eventStatistics?: Statistic
  status: string
}) => {
  return (
    <div className="flex items-center justify-stretch space-x-4">
      {status === 'published' && (
        <>
          <div className="flex items-center p-6 bg-white rounded-lg shadow-md w-full">
            <div className="flex items-centerjustify-center rounded p-2 mr-4 bg-green-100">
              <Image
                src={FileCheckIcon}
                className="w-6 h-6 text-green-700"
                alt="Registering"
                style={{
                  maxWidth: "100%",
                  height: "auto"
                }} />
            </div>
            <div className="flex flex-col items-start">
              <span className="text-xl font-bold text-gray-900">
                {eventStatistics?.register_now || 0} Registrations Open
              </span>

              <span className="text-sm text-gray-600">
                Accepting new registrations
              </span>
            </div>
          </div>
          <div className="flex items-center p-6 bg-white rounded-lg shadow-md w-full">
            <div className="flex items-centerjustify-center rounded p-2 mr-4 bg-blue-100">
              <Image
                src={BellRingIcon}
                className="w-6 h-6 text-blue-700"
                alt="Ongoing"
                style={{
                  maxWidth: "100%",
                  height: "auto"
                }} />
            </div>
            <div className="flex flex-col items-start">
              <span className="text-xl font-bold text-gray-900">
                {eventStatistics?.ongoing || 0} Ongoing
              </span>

              <span className="text-sm text-gray-600">
                Hacking and Submissions period live
              </span>
            </div>
          </div>
          <div className="flex items-center p-6 bg-white rounded-lg shadow-md w-full">
            <div className="flex items-centerjustify-center rounded p-2 mr-4 bg-indigo-100">
              <Image
                src={RocketIcon}
                className="w-6 h-6 text-green-700"
                alt="Upcoming"
                style={{
                  maxWidth: "100%",
                  height: "auto"
                }} />
            </div>
            <div className="flex flex-col items-start">
              <span className="text-xl font-bold text-gray-900">
                {eventStatistics?.upcoming || 0} Upcoming
              </span>

              <span className="text-sm text-gray-600">
                Registrations not yet open
              </span>
            </div>
          </div>
        </>
      )}
      {status === 'draft' && (
        <div className="w-1/3 flex items-center p-6 bg-white rounded-lg shadow-md">
          <div className="flex items-centerjustify-center rounded p-2 mr-4 bg-gray-100">
            <Image
              src={CalendarPlusIcon}
              className="w-6 h-6 text-gray-700"
              alt="Scheduled"
              style={{
                maxWidth: "100%",
                height: "auto"
              }} />
          </div>
          <div className="flex flex-col items-start">
            <span className="text-xl font-bold text-gray-900">0 Scheduled</span>

            <span className="text-sm text-gray-600">
              for Automatic Publishing
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default Statistics
